import React, {useState, Fragment, useEffect} from 'react'
// import ArrowBack from '@material-ui/icons/ArrowBack'
import {
    Button,
    Grid,
    FormControl,
    InputLabel,
    Input,
    FormHelperText,
    Typography,
    Snackbar,
} from '@material-ui/core/'
import MuiAlert from '@material-ui/lab/Alert'
import FormBuilder from '../../components/FormBuilder'
import TermAndCondition from '../../components/TermAndCondition'
import FigmdCaptcha from '../../components/FigmdCaptcha/index'
import {API_URL_RESOURCE, HTTP_CALL_TYPE} from '../../utils/constants'
import EmailSent from '../../components/EmailSent'
import {useFormReducerHook} from '../../utils/customHooks'
import CaptchaImg from '../../assets/images/recaptch-img.svg'
import {Link, Redirect} from 'react-router-dom'
import Loader from '../../components/Loader'
import {useSettings} from '../../utils/Settings'
import {registrationEmail, getValidateSession} from '../../services/outReach'
import ArrowBack from '@material-ui/icons/ArrowBack'
import {element} from 'prop-types'
import get from 'get-value'
import {load} from '@amcharts/amcharts4/.internal/core/utils/Net'
import {apiRequest} from '../../utils/apiHelper'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

function EmailVerificationRequired(props) {
    return (
        <div>
            Your Email address is not verified <b /> Follow email steps to verify the
            email.
            <Grid item xs={12} className="loader__container">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        props.onClickContinue()
                    }}
                >
                    Continue
                </Button>
            </Grid>
        </div>
    )
}

const saveEntityId = id => {
    sessionStorage.setItem('sessionClientEntityId', String(id))
}

const saveParentEntityId = id => {
    sessionStorage.setItem('sessionParentClientEntityId', String(id))
}

const SignUp = props => {
    // const [captcha, setCaptcha] = useState('')
    // const [toggleRefresh, settoggleRefresh] = useState(false)
    const [emailsent, setEmailSent] = useState(false)
    const [isemailverificationrequired, setIsemailverificationrequired] = useState(false)
    const [userCaptcha, setuserCaptcha] = useState('')
    const [captchaError, setCaptchaError] = useState(false)
    const [captchaImgSrc, setCaptchaImgSrc] = useState('')
    const [signupError, setSignupError] = useState('')
    const [loading, setloading] = useState(false)
    const [termCondition, setTermCondition] = useState({checkedA: false})
    const [termAndUseError, setTermAndUseError] = useState(false)
    const [preAuthenticate, setPreAuthenticate] = useState(false)

    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate,
        validateForKey,
        updateEntireFormData,
    } = useFormReducerHook()
    const {appConfig, login} = useSettings()
    const [captchaErrorText, setCaptchaErrorText] = useState(
        appConfig.supportedLabels.signup.captchaError
    )
    const [open, setOpen] = useState(false)
    const [sentEmailMessage, setEmailMessage] = useState('')
    const [preVerificationRequired, setPreVerificationRequired] = useState(false)
    const [continuetoken, setContinuetoken] = useState('')
    const [redirectParams, setRedirectParams] = useState(undefined)
    const [signUpFormSchema, setSignUpFormSchema] = useState(
        appConfig.signUpFormProps || {}
    )

    const myAccountNewPracticeEnroll =
        props &&
        props.location &&
        props.location.state &&
        props.location.state.isnewpracticeassociation &&
        props.location.state.isnewpracticeassociation === 'true'
            ? true
            : false

    useEffect(() => {
        if (window.history.state && window.history.state.state !== undefined) {
            const incomingData = JSON.parse(JSON.stringify(window.history.state.state))
            setPreAuthenticate(true)
            Object.keys(incomingData).forEach(key => {
                let checkObj = toParamsToObj(incomingData[key])
                if (typeof checkObj == 'object') incomingData[key] = checkObj
            })
            DisableFormFields(incomingData)
            updateEntireFormData(incomingData)
            window.history.replaceState(undefined, 'state')
        } else {
            if (appConfig.preVerificationRequired) {
                setPreVerificationRequired(true)
            }
        }
        loadCaptch()
    }, [])

    const loadCaptch = async () => {
        const cid = sessionStorage.getItem('cid')
        const token = cid !== null && cid !== undefined ? {cid} : {}
        const response = await apiRequest(
            API_URL_RESOURCE.URL + API_URL_RESOURCE.GETCAPTCHA_API,
            token
        )

        if (response.success?.captchaImgSrc) {
            setCaptchaImgSrc(response.success.captchaImgSrc)
            sessionStorage.setItem('cid', response.success.cid)
        }
    }

    const toParamsToObj = obj => {
        try {
            return JSON.parse(obj)
        } catch (e) {
            return obj
        }
    }

    const DisableFormFields = formData => {
        const formSchema = signUpFormSchema
        formSchema.forEach(element => {
            if (Array.isArray(element.value)) {
                element.value.forEach(field => {
                    const fieldval = get(formData, field.columnName)
                    if (fieldval) {
                        switch (field.componentType.toUpperCase()) {
                            case 'INPUTFIELD':
                                field.disabled = true
                                break
                            case 'PHONE':
                                field.isDisable = true
                                break
                            case 'REACTSELECT':
                                field.isDisabled = true
                                break
                            default:
                                break
                        }
                    }
                })
            }
        })
        // console.log(formSchema);
        setSignUpFormSchema(formSchema)
    }

    const captchaValidation = () => {
        if (userCaptcha !== '' || preAuthenticate) {
            return true
        } else {
            if (userCaptcha) {
                setCaptchaErrorText(appConfig.supportedLabels.signup.wrongCaptch)
            } else {
                setCaptchaErrorText(appConfig.supportedLabels.signup.captchaError)
            }
            setCaptchaError(true)
            // settoggleRefresh(!toggleRefresh)
            loadCaptch()
            return false
        }
    }

    const termOfUseValidation = () => {
        if (appConfig.termCondition) {
            if (!termCondition.checkedA) {
                setTermAndUseError(true)
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    }

    const submitForm = async () => {
        setloading(true)
        setSignupError('')
        let isValid = true
        if (!validate()) {
            isValid = false
        }

        if (!captchaValidation()) {
            isValid = false
        }

        if (!termOfUseValidation()) {
            isValid = false
        }

        if (isValid) {
            try {
                let inputData = {...formData}
                if (
                    appConfig.excludeFromPayload &&
                    appConfig.excludeFromPayload.length > 0
                ) {
                    appConfig.excludeFromPayload.map(key => {
                        delete inputData[key]
                        return key
                    })
                }
                if (!preAuthenticate) {
                    inputData['captcha'] = userCaptcha
                    inputData['cid'] = sessionStorage.getItem('cid')
                }
                const header = {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                }

                if (inputData.cliententityid) {
                    header['client-entity-id'] = inputData.cliententityid
                    delete inputData['cliententityid']
                }

                const response = await fetch(
                    API_URL_RESOURCE.URL + API_URL_RESOURCE.REGISTRATION_API,
                    {
                        method: HTTP_CALL_TYPE.POST, // *GET, POST, PUT, DELETE, etc.
                        headers: header,
                        body: JSON.stringify(inputData),
                        credentials: 'include',
                    }
                )
                setFormData({})
                const res = await response.json()
                setloading(false)
                if (Object.entries(res.error).length > 0) {
                    loadCaptch()
                    setSignupError(res.error.message)
                } else {
                    if (res.success.cliententityid) {
                        saveEntityId(res.success.cliententityid)
                    }
                    if (res.success.parentcliententityid) {
                        saveParentEntityId(res.success.parentcliententityid)
                    }
                    if (res.success.continuetoken)
                        setContinuetoken(res.success.continuetoken)
                    if (res.success.isemailverificationrequired)
                        setIsemailverificationrequired(true)
                    else if (res.success.id)
                        setRedirectParams(
                            `?id=${res.success.id}&continuetoken=${res.success.continuetoken}`
                        )
                    else if (res.success.continuetoken)
                        handlecontinue(res.success.continuetoken)
                    else setEmailSent(true)
                }
            } catch (error) {
                setloading(false)
                console.log(error)
                setFormData({})
            }
        } else {
            setloading(false)
        }
    }

    // const result = captcha => {
    //     setCaptcha(captcha)
    // }

    const handleCaptcha = event => {
        setCaptchaError(false)
        setuserCaptcha(event.target.value)
    }

    const handleTermAndCondition = event => {
        setTermAndUseError(false)
        setTermCondition({...termCondition, [event.target.name]: event.target.checked})
    }

    const handleResend = async () => {
        const input = {
            loginname: (formData.loginname && formData.loginname.trim()) || '',
            emailaddress: (formData.emailaddress && formData.emailaddress.trim()) || '',
        }
        const result = await registrationEmail(input)
        if (Object.entries(result.error).length > 0) {
        } else {
            setEmailMessage(result.success.message)
            setOpen(true)
        }
    }

    const handleClose = () => setOpen(false)

    const onKeyUp = e => {
        if (e.keyCode === 13) submitForm()
    }

    useEffect(() => {
        document.title = appConfig.pageTitle.signup
    }, [appConfig.pageTitle.signup])

    const handlecontinue = async continuetoken => {
        const result = await getValidateSession(continuetoken)
        if (result.isemailverified) login()
        else {
            setEmailMessage('Email verification not done')
            setOpen(true)
        }
    }

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'

    const LoginLink = (
        <Grid item xs className="login__form-bottom-action">
            <span>{appConfig.supportedLabels.signup.alreadyHaveAccountTxt} </span>{' '}
            <Link to={loginPath}>
                <Button color="primary">
                    {' '}
                    {appConfig.supportedLabels.signup.loginBtnTxt}{' '}
                </Button>
            </Link>
        </Grid>
    )

    if (process.env.REACT_APP_ISMYACCOUNT === 'yes') {
        return <Redirect to="/login-my-account" />
    }

    if (preVerificationRequired) return <Redirect to="/registration" />
    if (redirectParams) return <Redirect to={`/registration${redirectParams}`} />

    return (
        <Fragment>
            <Snackbar
                open={open}
                autoHideDuration={3000}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                onClose={handleClose}
            >
                <Alert severity="success">{sentEmailMessage}</Alert>
            </Snackbar>
            {emailsent ? (
                <EmailSent onClickResend={handleResend} />
            ) : isemailverificationrequired ? (
                <EmailVerificationRequired
                    onClickContinue={handlecontinue(continuetoken)}
                />
            ) : (
                <Grid item className="login__contanier">
                    <Grid item className="login__signin">
                        <Grid item className="login__head">
                            <Typography
                                variant="h3"
                                className="login__title"
                                component="h2"
                            >
                                {appConfig.customization.preVerificationSelection && (
                                    <Link
                                        to="/registration"
                                        style={{textDecoration: 'none'}}
                                    >
                                        <ArrowBack name="arrow left" size="large" />{' '}
                                    </Link>
                                )}
                                {/* <ArrowBack name="arrow left" size="large" />{' '}*/}
                                {appConfig.supportedLabels.signup.signupHeader}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container className="login__form">
                        <FormBuilder
                            fields={signUpFormSchema}
                            formData={formData}
                            setFormData={setFormData}
                            onSubmit={submitForm}
                            errorsData={errorsData}
                            updateValidation={updateValidationData}
                            validateForKey={validateForKey}
                        />
                        <Grid
                            container
                            className="login__form-captcha__wrapper"
                            spacing={1}
                        >
                            {!preAuthenticate && (
                                <>
                                    <Grid item xs>
                                        <FormControl error={captchaError}>
                                            <InputLabel required>
                                                {
                                                    appConfig.supportedLabels.signup
                                                        .captchaHeadingTxt
                                                }
                                            </InputLabel>
                                            <Input
                                                onChange={handleCaptcha}
                                                placeholder={
                                                    appConfig.supportedLabels.signup
                                                        .captchaPlaceholder
                                                }
                                                inputProps={{
                                                    maxLength: String(5),
                                                }}
                                                onKeyUp={event => onKeyUp(event)}
                                            />
                                            <FormHelperText>
                                                {captchaError ? captchaErrorText : ''}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs>
                                        {/* <FigmdCaptcha
                                            result={result}
                                            toggleRefresh={toggleRefresh}
                                        /> */}

                                        <img alt="" src={captchaImgSrc}></img>
                                    </Grid>

                                    <Grid item xs className="Refresh-recaptch__container">
                                        <img
                                            onClick={() => loadCaptch()}
                                            src={CaptchaImg}
                                            alt="Refresh recaptch img"
                                            className="Refresh-recaptch__img"
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        {appConfig.termCondition && (
                            <Grid
                                container
                                className="login__form-trm-and-cnd__wrapper"
                                spacing={3}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    md
                                    className={`input-field__main_container  ${props.cssClass}`}
                                >
                                    <FormControl error={termAndUseError} fullWidth>
                                        <TermAndCondition
                                            checked={termCondition}
                                            onChange={handleTermAndCondition}
                                            appConfig={appConfig.termCondition}
                                        />
                                        <FormHelperText>
                                            {termAndUseError
                                                ? appConfig.termCondition.errorMessage
                                                : ''}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )}
                        <FormHelperText error>{signupError}</FormHelperText>
                        <Grid item xs className="login__form-action">
                            <Grid item xs={12} className="loader__container">
                                <Button
                                    disabled={loading}
                                    variant="contained"
                                    color="primary"
                                    onClick={submitForm}
                                >
                                    {appConfig.supportedLabels.signup.signupBtnTxt}
                                </Button>
                                {loading ? <Loader /> : null}
                            </Grid>
                            {!myAccountNewPracticeEnroll &&
                                (appConfig.customization.hideloginlink
                                    ? null
                                    : LoginLink)}
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Fragment>
    )
}

export default SignUp
